import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Table,
  Modal,
  message,
  InputNumber,
  Switch,
  Button,
  Radio,
  Tooltip,
  DatePicker,
} from "antd";
import NProgress from "nprogress";
import { fetchManualList, fetchHandleManual } from "../../../api/manual";
import "./index.scss";
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/manual", name: "人工处理" },
];
const { RangePicker } = DatePicker;
const { Column } = Table;

class Manual extends React.Component {
  state = {
    active: 1,
    untreated_listQuery: {
      pageNum: 1,
      pageSize: 10,
      mobilePhone: "",
      state: 0,
    },
    untreated_list: [],
    untreated_total: 0,
    treated_listQuery: {
      pageNum: 1,
      pageSize: 10,
      mobilePhone: "",
      tryBrandName: "",
      beginTime: "",
      endTime: "",
      state: 1,
    },
    treated_list: [],
    treated_total: 0,
  };
  changeTabs = (e) => {
    this.setState({
      active: e,
    });
  };
  handleSearch = () => {
    switch (this.state.active) {
      case 1:
        this.setState(
          {
            untreated_listQuery: {
              ...this.state.untreated_listQuery,
              pageNum: 1,
            },
          },
          () => this.getUntreatedList()
        );

        break;
      case 2:
        this.setState(
          {
            treated_listQuery: { ...this.state.treated_listQuery, pageNum: 1 },
          },
          () => this.getTreatedList()
        );

        break;
    }
  };
  getTreatedList = () => {
    fetchManualList(this.state.treated_listQuery).then((res) => {
      if (res.success) {
        this.setState({
          treated_list: res.data.list,
          treated_total: res.data.total,
        });
      }
    });
  };
  getUntreatedList = () => {
    fetchManualList(this.state.untreated_listQuery).then((res) => {
      if (res.success) {
        this.setState({
          untreated_list: res.data.list,
          untreated_total: res.data.total,
        });
      }
    });
  };
  componentDidMount() {
    NProgress.start();
    this.getUntreatedList();
    this.getTreatedList();
    NProgress.done();
  }
  inputChange = (e) => {
    switch (this.state.active) {
      case 1:
        this.setState({
          untreated_listQuery: {
            ...this.state.untreated_listQuery,
            [e.target.name]: e.target.value,
          },
        });
        break;
      case 2:
        this.setState({
          treated_listQuery: {
            ...this.state.treated_listQuery,
            [e.target.name]: e.target.value,
          },
        });
        break;
    }
  };
  dateChange = (date, dateString) => {
    this.setState({
      treated_listQuery: {
        ...this.state.treated_listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  renderState = (text) => {
    console.log(text);
    return text == 1 ? (
      "已绑定"
    ) : (
      <span style={{ color: "#F5A623" }}>未绑定</span>
    );
  };
  handleBind = (record) => {
    fetchHandleManual({ id: record.id }).then((res) => {
      if (res.success) {
        this.getUntreatedList();
        this.getTreatedList();
        message.success("绑定成功~");
      }
    });
  };
  render() {
    const {
      active,
      untreated_listQuery,
      untreated_list,
      untreated_total,
      treated_listQuery,
      treated_list,
      treated_total,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="manual_container">
          <div className="tabs">
            <div
              onClick={() => this.changeTabs(1)}
              className={active == 1 ? "item active" : "item"}
            >
              处理中心
            </div>
            <div
              onClick={() => this.changeTabs(2)}
              className={active == 2 ? "item active" : "item"}
            >
              处理记录
            </div>
            <div
              style={{ left: (active - 1) * 104 }}
              className="bottomLine"
            ></div>
          </div>
          <div className={active == 2 ? "card" : "none"}>
            <div className="searchTop">
              <RangePicker
                style={{ width: 250 }}
                className="marginR"
                onChange={this.dateChange}
              />
              <Input
                allowClear
                className="marginR"
                style={{ width: 180 }}
                name="mobilePhone"
                onChange={this.inputChange}
                value={treated_listQuery.mobilePhone}
                placeholder="请输入客户手机号码"
              />
              <Input
                allowClear
                className="marginR"
                style={{ width: 180 }}
                name="tryBrandName"
                onChange={this.inputChange}
                value={treated_listQuery.tryBrandName}
                placeholder="请输入品牌商"
              />
              <Button onClick={this.handleSearch} type="primary">
                搜索
              </Button>
            </div>
            <Table
              dataSource={treated_list}
              rowKey="id"
              pagination={{
                showTotal: () => `共${treated_total}条`,
                total: treated_total,
                current: treated_listQuery.pageNum,
                pageSize: treated_listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      treated_listQuery: {
                        ...treated_listQuery,
                        pageNum: page,
                      },
                    },
                    () => this.getTreatedList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      treated_listQuery: {
                        ...treated_listQuery,
                        pageSize,
                        pageNum: 1,
                      },
                    },
                    () => this.getTreatedList()
                  );
                },
              }}
            >
              <Column
                title="领取时间"
                dataIndex="createTime"
                key="createTime"
              />
              <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
              <Column
                title="用户微信昵称"
                dataIndex="nickName"
                key="nickName"
              />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column
                title="领取商品"
                dataIndex="materialsName"
                key="materialsName"
              />
              <Column
                title="品牌商"
                dataIndex="tryBrandName"
                key="tryBrandName"
              />
              <Column title="企业微信ID" dataIndex="corpid" key="corpid" />
              <Column
                title="绑定状态"
                dataIndex="bindingState"
                key="bindingState"
                render={this.renderState}
              />
              <Column
                title="处理时间"
                dataIndex="handleTime"
                key="handleTime"
              />
              <Column
                title="处理人"
                dataIndex="employeesName"
                key="employeesName"
              />
            </Table>
          </div>
          <div className={active == 1 ? "card" : "none"}>
            <div className="searchTop">
              <Input
                allowClear
                className="marginR"
                style={{ width: 220 }}
                name="mobilePhone"
                onChange={this.inputChange}
                value={untreated_listQuery.mobilePhone}
                placeholder="请输入客户手机号码"
              />
              <Button onClick={this.handleSearch} type="primary">
                搜索
              </Button>
            </div>
            <Table
              dataSource={untreated_list}
              locale={{ emptyText: "暂无数据，需输入手机号码查询" }}
              rowKey="id"
              pagination={{
                showTotal: () => `共${untreated_total}条`,
                total: untreated_total,
                current: untreated_listQuery.pageNum,
                pageSize: untreated_listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      untreated_listQuery: {
                        ...untreated_listQuery,
                        pageNum: page,
                      },
                    },
                    () => this.getUntreatedList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      untreated_listQuery: {
                        ...untreated_listQuery,
                        pageSize,
                        pageNum: 1,
                      },
                    },
                    () => this.getUntreatedList()
                  );
                },
              }}
            >
              <Column
                title="领取时间"
                dataIndex="createTime"
                key="createTime"
              />
              <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
              <Column
                title="用户微信昵称"
                dataIndex="nickName"
                key="nickName"
              />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column
                title="领取商品"
                dataIndex="materialsName"
                key="materialsName"
              />
              <Column
                title="品牌商"
                dataIndex="tryBrandName"
                key="tryBrandName"
              />
              <Column title="企业微信ID" dataIndex="corpid" key="corpid" />{" "}
              <Column
                title="绑定状态"
                render={this.renderState}
                dataIndex="bindingState"
                key="bindingState"
              />
              <Column
                title={() => (
                  <React.Fragment>
                    <span>操作</span>
                    <Tooltip
                      overlayClassName="manual_Tooltip"
                      placement="top"
                      title="将用户与品牌商进行绑定，绑定后数据处理完成，设备自动出货"
                    >
                      <div
                        style={{
                          display: "inline-block",
                          lineHeight: "18px",
                          width: 16,
                          height: 16,
                          backgroundColor: "#F5A623",
                          textAlign: "center",
                          color: "#FFF",
                          borderRadius: 9,
                          paddingLeft: 5,
                          marginLeft: 5,
                          cursor: "pointer",
                        }}
                      >
                        ？
                      </div>
                    </Tooltip>
                  </React.Fragment>
                )}
                render={(record) => {
                  return record.bindingState == 1 ? null : (
                    <a onClick={() => this.handleBind(record)}>绑定</a>
                  );
                }}
              />
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default Manual;
